var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("e-store-combo", {
                        attrs: {
                          id: "filters-store",
                          required: false,
                          placeholder: _vm.$t("Todos"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.storeChanged()
                          },
                        },
                        model: {
                          value: _vm.filters.storeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "storeId", $$v)
                          },
                          expression: "filters.storeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "order-paybox",
                          type: "vue-select",
                          label: _vm.$t("PDV"),
                          placeholder: _vm.$t("Selecione"),
                          options: _vm.payBoxesOptions,
                        },
                        model: {
                          value: _vm.filters.payboxId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "payboxId", $$v)
                          },
                          expression: "filters.payboxId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "filters-command",
                          type: "vue-select",
                          label: _vm.$t("Comando"),
                          placeholder: _vm.$t("Selecione"),
                          options: _vm.payBoxCommandsOptions(),
                        },
                        model: {
                          value: _vm.filters.command,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "command", $$v)
                          },
                          expression: "filters.command",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "filters-status-command",
                          type: "vue-select",
                          label: _vm.$t("Status"),
                          placeholder: _vm.$t("Selecione"),
                          options: _vm.statusCommandOptions,
                        },
                        model: {
                          value: _vm.filters.statusCommand,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "statusCommand", $$v)
                          },
                          expression: "filters.statusCommand",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "period",
                          type: "date-range-picker",
                          label: _vm.$t("Período"),
                        },
                        model: {
                          value: _vm.filters.rangeDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "rangeDate", $$v)
                          },
                          expression: "filters.rangeDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "platform",
                          type: "vue-select",
                          label: _vm.$t("Sistema Operacional"),
                          placeholder: _vm.$t("Selecione"),
                          options: _vm.platformOptions,
                        },
                        model: {
                          value: _vm.filters.platform,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "platform", $$v)
                          },
                          expression: "filters.platform",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-card-actions",
        {
          staticClass: "mb-2",
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.filterData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            ref: "command-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("PAYBOX_COMMAND.NAME"),
                "male",
                _vm.queryExecuted
              ),
              fields: _vm.fields,
              items: _vm.commands,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(payBoxId)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _vm._v(
                      " " +
                        _vm._s(item.payBox.number) +
                        "-" +
                        _vm._s(item.payBox.description) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(commandResponse)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("pre", { staticClass: "content-control" }, [
                      _vm._v(_vm._s(_vm.formatJson(item.commandResponse))),
                    ]),
                    _c("e-grid-actions", {
                      attrs: {
                        "show-update": false,
                        "show-delete": false,
                        buttons: [
                          {
                            icon: "arrows-fullscreen",
                            variant: "outline-primary",
                            title: _vm.$t("Visualizar resposta"),
                            event: "response-read-only",
                          },
                          {
                            icon: "clipboard",
                            variant: "outline-primary",
                            title: _vm.$t("Copiar"),
                            event: "response-copy",
                          },
                        ],
                      },
                      on: {
                        "response-read-only": function ($event) {
                          return _vm.showCommandResponseModal(
                            item.commandResponse
                          )
                        },
                        "response-copy": function ($event) {
                          return _vm.copyToClipboard(item.commandResponse)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "table-manage-pay-box",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("manage-pay-box-commands-sidebar", {
        ref: "managePayBoxCommandsSidebar",
        on: { "after-save": _vm.getData },
      }),
      _vm.$can("Create", "PayBoxCommand")
        ? _c("fab", {
            attrs: { "main-tooltip": _vm.$t("Cadastrar novo Comando") },
            on: { click: _vm.onShowSidebar },
          })
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            id: "commandResponseModal1",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            size: "xl",
            centered: "",
            title: _vm.$t("Resposta"),
          },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c("pre", [_vm._v(" " + _vm._s(_vm.commandResponse) + " ")]),
          _c(
            "b-row",
            {
              staticClass:
                "w-100 d-flex justify-content-between align-items-center",
            },
            [
              _c(
                "b-col",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c("e-button", {
                    staticClass: "mr-1",
                    attrs: {
                      variant: "outline-primary",
                      text: _vm.$t("Voltar"),
                      "text-shortcuts": ["ESC"],
                    },
                    on: {
                      click: function ($event) {
                        _vm.showModal = false
                      },
                    },
                  }),
                  _c("e-button", {
                    attrs: { variant: "primary", text: _vm.$t("Copiar") },
                    on: {
                      click: function ($event) {
                        return _vm.copyToClipboard(_vm.commandResponse)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }